import { render } from "./HintSystem.html?vue&type=template&id=2a4cc159&scoped=true"
import script from "./HintSystem.vue?vue&type=script&lang=js"
export * from "./HintSystem.vue?vue&type=script&lang=js"

import "./HintSystem.vue?vue&type=style&index=0&id=2a4cc159&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4cc159"]])

export default __exports__